import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminManagement from './pages/admin/AdminManagement';
import StudentManagement from './pages/admin/StudentManagement';
import AssessmentManagement from './pages/admin/AssessmentManagement';
import ResultsManagement from './pages/admin/ResultsManagement';
import AssessmentResultView from './pages/admin/AssessmentResultView';

// Student Pages
import StudentAssessment from './pages/student/StudentAssessment';
import AssessmentComplete from './pages/student/AssessmentComplete';

// Public Pages
import HomePage from './pages/HomePage';
import NotFound from './pages/NotFound';

function App() {
    return (
        <AuthProvider>
            <Router>
                <div className="App">
                    <Routes>
                        {/* Public Routes */}
                        <Route path="/" element={<HomePage />} />
                        <Route path="/admin/login" element={<AdminLogin />} />

                        {/* Student Assessment Routes */}
                        <Route path="/assessment/:token" element={<StudentAssessment />} />
                        <Route path="/assessment/:token/complete" element={<AssessmentComplete />} />

                        {/* Protected Admin Routes */}
                        <Route path="/admin/dashboard" element={
                            <ProtectedRoute>
                                <AdminDashboard />
                            </ProtectedRoute>
                        } />
                        <Route path="/admin/admins" element={
                            <ProtectedRoute requireSuperAdmin>
                                <AdminManagement />
                            </ProtectedRoute>
                        } />
                        <Route path="/admin/students" element={
                            <ProtectedRoute>
                                <StudentManagement />
                            </ProtectedRoute>
                        } />
                        <Route path="/admin/assessments" element={
                            <ProtectedRoute>
                                <AssessmentManagement />
                            </ProtectedRoute>
                        } />
                        <Route path="/admin/results" element={
                            <ProtectedRoute>
                                <ResultsManagement />
                            </ProtectedRoute>
                        } />
                        <Route path="/admin/results/:resultId" element={
                            <ProtectedRoute>
                                <AssessmentResultView />
                            </ProtectedRoute>
                        } />

                        {/* 404 Route */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>

                    <Toaster
                        position="top-right"
                        toastOptions={{
                            duration: 4000,
                            style: {
                                background: '#fff',
                                color: '#000',
                                border: '1px solid #e0e0e0',
                                borderRadius: '8px',
                                fontSize: '14px',
                            },
                            success: {
                                iconTheme: {
                                    primary: '#28a745',
                                    secondary: '#fff',
                                },
                            },
                            error: {
                                iconTheme: {
                                    primary: '#dc3545',
                                    secondary: '#fff',
                                },
                            },
                        }}
                    />
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;

